import errorLogger from './clientErrorLogger';
import infoLogger from './clientInfoLogger';

const getCarrierPostData = () => {
  try {
    const data = window.__POST_DATA__;
    errorLogger({ name: 'client-app-js', log: `getCarrierPostData, data: ${data} window: ${window}` });
    if (data === 'undefined') {
      errorLogger({ name: 'client-app-js', log: `getCarrierPostData, data is undefined, returning null` });
      return null;
    }
    const newData = window.atob(data);
    errorLogger({ name: 'client-app-js', log: `getCarrierPostData, newData: ${newData}` });
    const carrierPostDataJwt = JSON.parse(newData).carrierPostData;
    const carrierPostData = JSON.parse(atob(carrierPostDataJwt.split('.')[1]));
    return carrierPostData;
  } catch (error) {
    infoLogger({ name: 'client-app-js', log: 'Parsing postData failed, postData: ' + window.__POST_DATA__ });
    return {};
  }
};

const isNumber = (imsiString) => imsiString && !isNaN(imsiString);

function getImsiFromPostData() {
  let imsi;
  try {
    const carrierPostData = getCarrierPostData();
    errorLogger({ name: 'client-app-js', log: `getImsiFromPostData, carrierPostData: ${carrierPostData}` });
    if (Object.keys(carrierPostData).length > 0) {
      !carrierPostData.sid &&
        errorLogger({ name: 'client-app-js', log: 'CarrierPostData is missing sid: ' + window.__POST_DATA__ });
      const sid = carrierPostData.sid ? carrierPostData.sid : null;
      imsi = sid && isNumber(sid.split('@')[0]) ? sid.split('@')[0] : null;
      !imsi && errorLogger({ name: 'client-app-js', log: 'Failed to parse imsi from sid: ' + sid });
    } else {
      errorLogger({ name: 'client-app-js', log: 'Error post data is undefined' });
      imsi = window.location.pathname
        .split('/')
        .filter(Boolean)
        .slice(-2, -1)[0];
    }
  } catch (error) {
    errorLogger({ name: 'client-app-js', log: 'Error in getMsisdn: ' + error.message });
  }
  return imsi;
}

export default getImsiFromPostData;
